import React from 'react';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getMediaImageUrl } from 'client/utils/image-helpers';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { Link } from 'site-modules/shared/components/link/link';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

export function CompareModule({ entry }) {
  const compareVehicles = [];

  return (
    <div className="compare-module row text-center">
      {entry.vehicles.map((veh, i) => {
        const linkout = entry.links()[i];
        compareVehicles.push(`veh${i + 1}=${veh.style}`);
        return (
          <div
            className={classnames('mx-auto', {
              'col-3': entry.vehicles.length > 2,
              'col-5': entry.vehicles.length <= 2,
            })}
            key={`${veh.year} ${veh.make} ${veh.model} ${veh.submodel}`}
          >
            <Link
              className="similar-vehicles-link"
              to={`/${makeNiceName(veh.make)}/${makeNiceName(veh.model)}/${veh.year}/${makeNiceName(veh.submodel)}/`}
            >
              <AspectRatioContainer aspectRatio="3:2">
                <img
                  className="w-100 img-fluid mb-1"
                  src={getMediaImageUrl(linkout.href)}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              </AspectRatioContainer>
              <div>
                {veh.year} {veh.make} {veh.model} {veh.submodel}
              </div>
            </Link>
          </div>
        );
      })}
      <div className="cta-area col-12 my-3 mx-auto">
        <Link className="btn btn-success" to={`/car-comparisons/?${compareVehicles.join('&')}`}>
          Compare Similar Vehicles
        </Link>
      </div>
    </div>
  );
}

CompareModule.propTypes = {
  entry: CmsEntities.Content,
};

CompareModule.defaultProps = {
  entry: DEFAULT_CONTENT,
};
